export default "__VITE_ASSET__ylZKjEon__"